import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

import TableMFH from 'app/shared/components/TableMFH';

// style
import './style.scss';

const columnConfig = [
    {
        width: 5,
        dataKey: 'name',
        header: 'Property',
        isSortable: true,
        renderer: property => property.name,
    },
    {
        width: 4,
        dataKey: 'city',
        header: 'City',
        renderer: property => property.city,
    },
    {
        width: 2,
        dataKey: 'state',
        header: 'State',
        renderer: property => property.state,
    },
];

const propTypes = {
    onSubmit: PropTypes.func,
    properties: PropTypes.arrayOf(PropTypes.shape({
        zrnNumber: PropTypes.string,
        listingId: PropTypes.string,
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
    })).isRequired,
    selectedPropertyIndexes: PropTypes.object,
};

const defaultProps = {
    onSubmit: () => {},
    selectedPropertyIndexes: new Set(),
};

const PropertyPickerModal = ({
    onSubmit,
    properties,
    selectedPropertyIndexes,
}) => {
    const [selectedIndexes, setSelected] = React.useState(selectedPropertyIndexes);

    return (
        <div className="PropertyPickerModal">
            <div className="PropertyPickerModal-container">
                <StyledContainer borderLeft={true} borderRight={true}>
                    <TableMFH
                        columnConfig={columnConfig}
                        data={properties}
                        idKey="zrnNumber"
                        selected={selectedIndexes}
                        onSelectRow={setSelected}
                    />
                </StyledContainer>
            </div>
            <div className="PropertyPickerModal-controls">
                <Button
                    onClick={() => onSubmit(selectedIndexes)}
                    type="primary"
                >
                    Confirm
                </Button>
            </div>
        </div>
    );
};

PropertyPickerModal.propTypes = propTypes;
PropertyPickerModal.defaultProps = defaultProps;

export { PropertyPickerModal };
export default PropertyPickerModal;
